module.exports = __webpack_public_path__ + "img/sny04.c83229b2.jpg";